module.exports = __webpack_public_path__ + "img/btn-banner-promote.bc127f63.svg";